import React, {useState,useEffect} from 'react'
import './createProject.css'
import Nav from '../../globalComponents/nav/Nav';
import { MDBBtn, MDBTextArea, MDBInput } from 'mdb-react-ui-kit';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import Footer from '../../globalComponents/footer/Footer';
import Url from '../url'

function CreateProject() {
    const navigate = useNavigate()
    const [token,setToken] = useState(null)
    const [currentUserEmail, setCurrentUserEmail] = useState(undefined)
    const [admin, setAdmin ] = useState(null)

    //** Project info below */
    const [projectName, setProjectName] = useState("")

    const [projectDescription, setProjectDescription] = useState("")
    const [imageOfTheProject, setImageOfTheProject ] = useState()

    const [nameOfOriginalCreator, setNameOfOriginalCreator] = useState("")
    const [originalCreatorPhoto, setOriginalCreatorPhoto] = useState()

    const [projectType, setProjectType] = useState("")
    const [projectTypeOther, setProjectTypeOther] = useState("other")

    const [material, setMaterial] = useState("")
    const [pictureOfMaterial, setPictureOfMaterial] = useState()

    const [typeOfWork, setTypeOfWork] = useState("")
    const [typeOfWorkOther, setTypeOfWorkOther ] = useState("other")

    const [projectReciever, setProjectReciever] = useState("")

    const [printedPattern, setPrintedPattern] = useState(false)
    const [printedPatternPicture, setPrintedPatternPicture] = useState()

    const [ smokerOK, setSmokerOK ] = useState(false)
    const [ disclaimer, setDisclaimer ] =useState(false)

    useEffect(() => {
        if (localStorage.getItem("user")) {
            
            setCurrentUserEmail(localStorage.getItem("user"))
            localStorage.getItem("token")[3] == "Y" ?  setAdmin(true) : setAdmin(false)
            setToken(localStorage.getItem("token").slice(0,3)+localStorage.getItem("token").slice(4))
        }
    },[])

    // button to submit 
    function submitNewProject(e,draft){
        e.preventDefault()
        const formData = new FormData();
        formData.append("projectName",projectName)
        formData.append("projectDescription",projectDescription)
        formData.append("nameOfOriginalCreator",nameOfOriginalCreator)
        
        formData.append("projectReciever",projectReciever)
        formData.append("material",material)
        formData.append("printedPattern",printedPattern)
        formData.append("smokerOK",smokerOK)
        projectType == "other" 
            ? formData.append("projectType",projectTypeOther)
            : formData.append("projectType",projectType) 
        typeOfWork =="other"
            ? formData.append("typeOfWork",typeOfWorkOther)
            : formData.append("typeOfWork",typeOfWork)
        
        formData.append("draft",draft)

        formData.append("imageOfTheProject",imageOfTheProject)
        formData.append("originalCreatorPhoto",originalCreatorPhoto)
        formData.append("pictureOfMaterial",pictureOfMaterial)
        formData.append("printedPatternPicture",printedPatternPicture)
        

        function fetchToServer(){
            
            fetch (Url+`project/createProject`,{
                        method:"POST",
                        body: formData,
                        headers: new Headers({
                            //"Content-Type": "multipart/form-data",
                            "authorization" : token
                        })
                        
                    })
                    .then(res=> res.json())
                    .then(data=>{
                        data.error? alert(`${data.error}`) : navigate("/myProjects")
                    })
        }

        //check if this is a draft
        if (!draft){
            //check the diclaimer, than check if required fields are filled out
            if (!disclaimer) { 
                alert("You must agree to the conditions") 
            }
            else{
                if (!projectName || !projectDescription || !nameOfOriginalCreator){
                    alert("Project Name, Project Description, Original Creator are required")
                }
                else{//fetch 
                    fetchToServer()
                }
            }
        }
        else{ //this is draft -> just fetch everything to server
            !projectName ? alert("Project Name is required for Draft") :fetchToServer()
        }
    
    }
        
    return (
        <>
            <Nav token={token} admin={admin} email={currentUserEmail}></Nav>
                <div className='container-sm' style={{marginTop:"120px"}}>

                    <div className="row pb-3">
                            <h2>Create new project</h2>
                    </div>
                    
                    <div className="row-lg pb-4">
                        <button type="button" className="btn btn-primary">Click here for private submission</button>
                    </div>
                    
                    <div className="row pb-4">
                        <div className='row'>
                            <div className="col-md-7 pb-1">
                                <MDBInput value={projectName} 
                                    placeholder="Give your project a name e.g: Aunt Anna's scarf. "
                                    label='Project Name' 
                                    onChange={e => {setProjectName(e.target.value)}}/>
                            </div>
                            
                            <div className="col-md-4 pb-1" style={{display:"flex",alignItems:"center",gap:"0.5em"}}>
                                Photo:
                                <input type="file" className="form-control" id="projectPhoto" accept="image/*"
                                    onChange={(e)=> {
                                        e.target.files.length > 0 
                                            ? setImageOfTheProject(e.target.files[0]) 
                                            : setImageOfTheProject(null)}
                                        }
                                />
                            </div>
                        </div>
                        
                        {imageOfTheProject &&
                        <div className='row-lg'>
                            <img className='custom' src={imageOfTheProject ? URL.createObjectURL(imageOfTheProject) : null} alt="No photo selected"  />
                        </div>
                        }
                    </div>    
                    

                    <div className="row-lg pb-4" >
                        <MDBTextArea style={{minWidth: "100%"}}
                            placeholder='Decribe the project and the story behind it'
                            value={projectDescription}
                            onChange={e=>{setProjectDescription(e.target.value)}}
                            label='Describe your project'>
                        </MDBTextArea>
                    </div>
                    
                    <div className="row-lg pb-4">
                        <div className='row'>
                            <div className="col-md-7 pb-1">
                                <MDBInput value={nameOfOriginalCreator} 
                                    placeholder='Who started the project'
                                    label='Name of original creator' 
                                    onChange={e => {setNameOfOriginalCreator(e.target.value)}}/>
                            </div>
                        
                            <div className="col-md-4 pb-1" style={{display:"flex",alignItems:"center",gap:"0.5em"}}>
                                Photo: 
                                <input  type="file" className="form-control" id="originalCreatorPhoto"
                                    onChange={(e)=> {
                                        e.target.files.length > 0 
                                        ? setOriginalCreatorPhoto(e.target.files[0]) 
                                        : setOriginalCreatorPhoto(null)}
                                    }/>
                            </div>
                        </div>
                        {originalCreatorPhoto &&
                        <div className='row-lg'>
                            <img className='custom' src={originalCreatorPhoto ? URL.createObjectURL(originalCreatorPhoto) : null} alt="No photo selected"  />
                        </div>
                        }
                    </div>

                    <div className="row">
                        <div className="col pb-4">
                            <MDBInput value={projectReciever} 
                                placeholder='For whom was the project intended'
                                label='For whom was the project intended' 
                                onChange={e => {setProjectReciever(e.target.value)}}/>
                        </div>
                        
                        <div className="col-md-5" style={{display:"flex",alignItems:"center",gap:"0.5em"}}>
                            {/* add image of project receiver ??? */}
                        </div>
                    </div>


                    <div className='row-lg'>
                    Type of project (hat, gloves, ...)
                    </div>
                    
                    <div className="row pb-4">
                        <div className="col-md-3 pb-1" >
                                <Form.Select className="projectType" value={projectType} aria-label="Project type" onChange={e=>setProjectType(e.target.value)}>
                                    <option value=""></option>
                                    <option value="hat">Hat</option>
                                    <option value="scarf">Scarf</option>
                                    <option value="shawl-wrap">Shawl / Wrap</option>
                                    <option value="gloves">Gloves</option>
                                    <option value="mittens">Mittens</option>
                                    <option value="socks">Socks</option>
                                    <option value="sweater">Sweater</option>
                                    <option value="cowl">Cowl</option>
                                    <option value="rugs">Rugs</option>
                                    <option value="blanket">Blanket</option>
                                    <option value="dress">Dress</option>
                                    <option value="coat-jacket">Coat / Jacket</option>
                                    <option value="dolls-stuffies">Dolls / Stuffies</option>
                                    <option value="bag">Bag</option>
                                    <option value="other">Other</option>
                                    <option value="unknown">I don't know</option>
                                </Form.Select>
                        </div>
                        
                        <div className="col-md-5" >
                            {projectType =="other" && <MDBInput label="Other project type" placeholder='enter other type of project' 
                                                                        onChange={e=>setProjectTypeOther(e.target.value)}
                                                                        value={projectTypeOther}></MDBInput>
                            }
                            {projectType =="unknown" && 
                                    <p>Provide as much information as possible in the project description above.</p>
                                
                                }
                        </div>
                    </div>
                    

                    <div className='row-lg'>
                    Type of work (knitting, quilting, ...)
                    </div>
                    <div className="row pb-4">
                    <div className="col-md-3 pb-1" >
                                <Form.Select className="projectType" value={typeOfWork} aria-label="Default select example" onChange={e=>setTypeOfWork(e.target.value)}>
                                    <option value=""></option>
                                    <option value="knitting">Knitting</option>
                                    <option value="crocheting">Crocheting</option>
                                    <option value="quilting">Quilting</option>
                                    <option value="embroidery">Embroidery</option>
                                    <option value="sewing">Sewing</option>
                                    <option value="crossStitch">Cross Stitch</option>
                                    <option value="weavingTapestry">Weaving/Tapestry</option>
                                    <option value="weavingLoom">Weaving/Loom</option>
                                    <option value="lace">Lace</option>
                                    <option value="braided"> Rug-Making</option>
                                    <option value="other">Other</option>
                                    <option value="unknown">I don't know</option>
                                </Form.Select>
                        </div>
                        
                        <div className="col-md-5" style={{textAlign:"left",alignSelf:"center"}} >
                            {typeOfWork =="other" && <MDBInput label="Other type of work" placeholder='enter other type of work' 
                                                                        onChange={e=>setTypeOfWorkOther (e.target.value)}
                                                                        value={typeOfWorkOther}></MDBInput>
                            }
                            {typeOfWork =="unknown" && <p>
                                    Provide as much information as possible in the project description above.
                                </p>
                                }
                        </div>
                    </div>

                    <div className="row pb-4">
                        <div className='row'>
                            <div className="col-md-7 pb-1">
                                <MDBInput value={material} 
                                    placeholder="Enter the type of material used in you project "
                                    label='Materials used (wool, cashmere, ... )' 
                                    onChange={e => {setMaterial(e.target.value)}}/>
                            </div>
                                
                            <div className="col-md-4 pb-1" style={{display:"flex",alignItems:"center",gap:"0.5em"}}>
                                    Photo:
                                    <input type="file" className="form-control" id="projectMaterial" accept="image/*"
                                        onChange={(e)=> {
                                            e.target.files.length > 0 
                                                ? setPictureOfMaterial(e.target.files[0]) 
                                                    : setPictureOfMaterial(null)}
                                    }/>
                            </div>

                            {pictureOfMaterial &&
                                <div className='row-lg'>
                                    <img className='custom' src={pictureOfMaterial ? URL.createObjectURL(pictureOfMaterial) : null} alt="No photo selected"  />
                                </div>
                            }
                        </div>
                    </div>

                    <div className="row pb-4">
                        <div className='row'>
                            <div className="col-md-3 pb-1">
                                <div className="form-check">
                                    <input className="form-check-input" checked={printedPattern} 
                                        type="checkbox" id="patterCheckbox" 
                                        onChange={e=>{
                                            setPrintedPattern(e.target.checked)
                                            !e.target.checked ? setPrintedPatternPicture(null) :null

                                            }}/>
                                    <label className="form-check-label" htmlFor="patternCheckbox">Project has a pattern? </label>
                                </div>
                            </div>
                            <div className='col-md-4 pb-1' style={{display:"flex",alignItems:"center",gap:"0.5em"}}>
                                { printedPattern &&
                                    <>
                                    Photo of pattern instructions :
                                    <input type="file" className="form-control" id="printedPatternPicture" accept="image/*"
                                        onChange={(e)=> {
                                            e.target.files.length > 0 
                                                ? setPrintedPatternPicture(e.target.files[0]) 
                                                    : setPrintedPatternPicture(null)}
                                        }/>
                                    </>
                                }
                            </div>
                        </div>
                        
                        { printedPatternPicture &&
                        <div className="row-lg">
                            <img className='custom' src={printedPatternPicture ? URL.createObjectURL(printedPatternPicture) : null} alt="No photo selected"  />
                        </div>
                        }   
                    </div>
                    
                    <div className="row pb-4">
                        <div className="col-md-5 pb-2">
                            <div className="form-check">
                                <input className="form-check-input" checked={smokerOK} type="checkbox" name="" id="smokerOkCheckbox" onChange={e=>setSmokerOK(e.target.checked)}/>
                                <label className="form-check-label" htmlFor="smokerOkCheckbox">I am OK with a smoker finishing my project</label>
                            </div>
                        </div>
                    </div>


                    <div className="row pb-4">
                        <div className="col-md-2">
                            <h6>Disclaimer:</h6>
                        </div>
                        <div className="col-md-3 pb-2">
                            <p>Submissions through this portal will be publicly viewable. For private submissions see link above. By clicking below, you recognize that Loose Ends is not responsible for lost or damaged projects or materials.   </p>
                        </div>
                    </div>
                    
                    <div className="row pb-4">
                        <div className="col-md-3 pb-2">
                            <div className="form-check">
                                <input className="form-check-input" checked={disclaimer} type="checkbox" name="" id="disclaimerCheckbox" onChange={e=>setDisclaimer(e.target.checked)}/>
                                <label className="form-check-label" htmlFor="disclaimerCheckbox">I agree to the conditions stated above</label>
                            </div>
                        </div>
                    </div>



                    <div className='row pb-4'>
                        <div className='col pb-2' style={{textAlign:"center"}}>
                            <MDBBtn className="buttonsBottom" onClick={e=>{submitNewProject(e,false)}}>Create Project</MDBBtn>
                        </div>
                        
                        <div className='col pb-2'style={{textAlign:"center"}}>
                            <MDBBtn className="buttonsBottom" onClick={e=>{submitNewProject(e,true)}}>Save Draft</MDBBtn>
                        </div>
                        
                        <div className='col pb-2' style={{textAlign:"center"}}>
                            <MDBBtn className="buttonsBottom" type="button" onClick={e=>navigate("/myProjects")}>Cancel</MDBBtn>
                        </div>
                    </div>
                </div>
        <Footer/>
        </>
    )
}

export default CreateProject
